import React, { useContext } from 'react'
import Modal from 'components/Luxkit/Modal/Modal'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { pluralizeToString } from 'lib/string/pluralize'
import FormatCurrency from 'components/Common/FormatCurrency'
import Group from 'components/utils/Group'
import Divider from 'components/Luxkit/Divider'
import LargeContentToggle from 'components/Common/LargeContentToggle'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextButton from 'components/Luxkit/Button/TextButton'
import { ModalElementContext } from 'contexts/ModalProvider'
import { arrayToStringListFormat } from 'lib/string/stringUtils'

interface Props {
  offer: App.CarHireOffer;
  onReserve: (offer: App.CarHireOffer) => void;
}

function CarHirePriceDetailsModal(props: Props) {
  const { offer, onReserve } = props
  const modalContext = useContext(ModalElementContext)

  const onClick = () => {
    onReserve(offer)
    modalContext.resolve()
  }

  const payOnArrivalItemsString = arrayToStringListFormat(offer.payOnArrivalItems, 'and')

  return (
    <Modal title="Price details" size="L">
      <Group gap={32} direction="vertical">
        <VerticalSpacer gap={16}>
          <Group direction="horizontal" horizontalAlign="space-between">
            <BodyText variant="medium" weight="bold">Car Hire ({pluralizeToString('day', offer.duration)})</BodyText>
            <BodyText variant="medium"><FormatCurrency value={offer.payNowAmount} /> total</BodyText>
          </Group>

          {offer.payOnArrivalAmount > 0 &&
            <>
              <Divider kind="primary" />
              <Group direction="vertical">
                <Group direction="horizontal" horizontalAlign="space-between">
                  <BodyText variant="medium" weight="bold">Taxes & fees</BodyText>
                  <BodyText variant="medium"><FormatCurrency value={offer.payOnArrivalAmount} /></BodyText>
                </Group>
                <div>
                  <BodyText variant="medium">Due at pick-up</BodyText>
                  <LargeContentToggle
                    maxHeight={0}
                    showMoreText="Read more"
                    showLessText="Read less"
                  >
                    {offer.payOnArrivalItems.length > 0 &&
                      <BodyText variant="medium">
                        This charge includes estimated amounts the supplier requires for <b>{payOnArrivalItemsString}</b>. Please note that this fee will be payable directly at pick-up.
                      </BodyText>
                    }

                    {offer.payOnArrivalItems.length <= 0 && <BodyText variant="medium">
                      This charge covers estimated supplier fees. Please note that this fee will be payable directly at pick-up.
                    </BodyText>}
                  </LargeContentToggle>
                </div>
              </Group>
            </>
          }

          <Divider kind="primary" />
          <Group direction="horizontal" horizontalAlign="space-between">
            <BodyText variant="large" weight="bold">Total</BodyText>
            <BodyText variant="large" weight="bold"><FormatCurrency value={offer.payNowAmount + offer.payOnArrivalAmount} /></BodyText>
          </Group>
        </VerticalSpacer>

        <Group direction="horizontal" tabletHorizontalAlign="end">
          <TextButton kind="primary" onClick={onClick}>Reserve</TextButton>
        </Group>

      </Group>

    </Modal>
  )
}

export default CarHirePriceDetailsModal
